import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Modal from '../../../components/helpers/Modal';
import SelectField from '../../../components/forms/SelectField';
import { formDataSelector, dependenciesSelector } from '../../../selectors/admin/forms';
import { MODELS } from '../../../constants/admin/settings';
import { toSelectionFormat } from '../../../lib/collection.utils';
import { find } from 'lodash';
import { onInput, reset } from '../../../actions/admin/forms';
import { timeToMs } from '../../../lib/date.utils';
import Datepicker from '../../../components/forms/Datepicker';
import CKPButton from '../../../components/forms/Button';
import { createFromPerformanceModal } from '../../../actions/admin/models/contracts';
import TextArea from '../../../components/forms/TextArea';
import { parseModalContract } from '../../../selectors/admin/models/contacts';

class PerformancesContractForm extends Component {
    state = { fetchingSigners: false };

    componentDidUpdate(prevProps) {
        if (prevProps.open === false && this.props.open) {
            this.setState({ fetchingSigners: true });
            this.props.fetchSigningUsers(this.props.organizationId, this.props.artistId, this.props.eventId, () =>
                this.setState({ fetchingSigners: false })
            );
        }
    }
    _selectTemplate = id => {
        const template = find(this.props.dependencies.templates, x => x.id === id);
        this.props.onInput(MODELS.CONTRACT, 'data', template.data || '');
        this.props.onInput(MODELS.CONTRACT, 'templateId', id);
        template.clearing && this.props.onInput(MODELS.CONTRACT, 'templateClearing', template.clearing);
    };
    _input = (v, f) => this.props.onInput(MODELS.CONTRACT, f, v);
    _close = () => {
        this.props.reset(MODELS.CONTRACT);
        this.props.onClose();
    };
    _submit = async (andSend = false) => {
        const data = await parseModalContract(this.props);
        this._close();
        this.props.createFromPerformanceModal(data, andSend);
    };
    render() {
        return (
            <Modal className="ckp-performances-contracts is-big" open={this.props.open} onClose={this._close}>
                <React.Fragment>
                    <h4 className="ckp-ts-h1 u-margin-bottom-2">Add Clearance Contract</h4>
                    <div className="ckp-admin-grid-row">
                        <div className="ckp-admin-grid-column">
                            <SelectField
                                items={toSelectionFormat(this.props.dependencies.templates)}
                                label="Contract Template *"
                                onChange={this._selectTemplate}
                                name="templateId"
                                value={this.props.data.templateId}
                            />
                        </div>
                        <div className="ckp-admin-grid-column">
                            <Datepicker
                                minDate={timeToMs()}
                                value={this.props.data.dueDate > 0 ? this.props.data.dueDate : ''}
                                onChange={this._input}
                                label={'Contract Due Date *'}
                                name={'dueDate'}
                            />
                        </div>
                    </div>
                    <div className="ckp-admin-grid-row">
                        <TextArea
                            label="Signers"
                            className="is-small is-full-width"
                            value={
                                this.state.fetchingSigners
                                    ? 'Fetching signers...'
                                    : (this.props.dependencies.signers && this.props.dependencies.signers.join('\n')) ||
                                      'No signers found...'
                            }
                            disabled={true}
                        />
                    </div>
                    <div className="ckp-admin-grid-row is-between u-margin-top-2">
                        <div className="ckp-admin-grid-column no-margin">
                            <CKPButton
                                onClick={() => this._submit(false)}
                                inactive={!this.props.data.dueDate || !this.props.data.templateId}
                                className="is-small"
                                label="Save as draft"
                            />
                        </div>
                        <div className="ckp-admin-grid-column no-margin">
                            <CKPButton onClick={this._close} className="is-sub is-small" label="Cancel" />
                            <CKPButton
                                inactive={
                                    !this.props.data.dueDate ||
                                    !this.props.data.templateId ||
                                    !this.props.dependencies.signers ||
                                    this.state.fetchingSigners
                                }
                                onClick={() => this._submit(true)}
                                className=" is-small"
                                label="Send"
                            />
                        </div>
                    </div>
                </React.Fragment>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    data: formDataSelector(state, { model: MODELS.CONTRACT }),
    performanceData: formDataSelector(state, { model: MODELS.ENTRY }),
    dependencies: dependenciesSelector(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({ createFromPerformanceModal, onInput, reset }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PerformancesContractForm);
